import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ShipmentId} from "../shipment-id";
import { shipmentIdZodSchema } from "../shipment-id";

type ShipmentPickupCommand = {
    readonly _id: string;
    readonly _type: "SHIPMENT_PICKUP_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly shipmentId: ShipmentId;
};

type FactoryParams = Except<
    ShipmentPickupCommand,
    "_id" | "_type" | "_createdAt"
>;
const createShipmentPickupCommand = (params: FactoryParams) => {
    const command: ShipmentPickupCommand = {
        ...params,
        _id: generateId({ prefix: "shipment_pickup_command__" }),
        _type: "SHIPMENT_PICKUP_COMMAND",
        _createdAt: nowIsoAndUnix(),
        shipmentId: params.shipmentId,
    };
    return command;
};

const shipmentPickupIdZodSchema = idZodSchema.regex(
    /^shipment_pickup_command__.*$/,
);

const shipmentPickupZodSchema: z.ZodSchema<ShipmentPickupCommand> = z.object({
    _id: shipmentPickupIdZodSchema,
    _type: z.literal("SHIPMENT_PICKUP_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    shipmentId: shipmentIdZodSchema,
});

export { createShipmentPickupCommand, shipmentPickupZodSchema };
export type {
    FactoryParams as CreateShipmentPickupCommandParams,
    ShipmentPickupCommand,
};
